import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { EcoStoreIcon } from '../../../assets/icons';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';
import { getPendingFranchisesRequest } from '../../actions/certificationActions';

const TobeFranchiseList = ({ history }) => {

    const dispatch = useDispatch();

    const { listFranchiseRequest } = useSelector((state) => state.certificationAdmin);

    useEffect(() => {
        dispatch(getPendingFranchisesRequest())
    }, [])

    return (
        <div className='container-page scroll-menu'>
            <TitleSVG Icon={EcoStoreIcon}
                titleHighlight={'Lista'}
                title={' de solicitudes de ser Ecotienda'}
            />
            <div className='d-flex centerContent mt-5'>
                {(listFranchiseRequest?.length != 0) ?
                    <div className='wrapper-5 column-gap row-gap container-width'>
                        {listFranchiseRequest && listFranchiseRequest.map((listFranchiseRequest, index) => (
                            <div key={listFranchiseRequest._id} className="card-admin">
                                <div className="tittle-card-admin center-text">{listFranchiseRequest.userID.name}</div>
                                <div className="tittle-card-admin center-text mb-1">{listFranchiseRequest.userID.lastname}</div>
                                <div className="text-content-card center-text">{listFranchiseRequest.state ===0 ? "Pendiente" : ""}</div>
                                <div className="btns-admin ml-2 mr-2 mt-3" onClick={() => { history.push("./CertificateFranchiseAuthRequest/" + listFranchiseRequest._id) }}
                                >Ver Información</div>
                            </div>
                        ))
                        }
                    </div> :
                    <div className='color-purple-dark text-fz-1-5 container-width '> {'No hay Solicitudes pendientes'}</div>
                }
            </div>
        </div>
    )
}

export default TobeFranchiseList
